import { render, staticRenderFns } from "./ziyuan132.vue?vue&type=template&id=01c62bfb&"
import script from "./ziyuan132.vue?vue&type=script&lang=js&"
export * from "./ziyuan132.vue?vue&type=script&lang=js&"
import style0 from "./ziyuan132.vue?vue&type=style&index=0&id=01c62bfb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports